/*
 * @Description:
 * @Author: luckymiaow
 * @Date: 2022-05-24 17:58:47
 * @LastEditors: luckymiaow
 */

import { computed, onMounted, ref, shallowRef, unref } from 'vue';
import type { IStandardProps, StandardModel } from '../types';
import useForm, { readOnlySlot } from '../../form/src/useFormConfig';
import { FormConfig } from '../../form/types';

const oldVersion = ref<string>();

const version = ref('0.01'); // 标准版本

const standardRec = ref<Record<string, StandardModel>>({});

export default <T extends IStandardProps>({ attrs, props }: any) => {
  const { getBindValue } = useForm<FormConfig & T>({ componentName: 'standard', attrs, props });

  const standard = ref<StandardModel>();

  const loading = ref(true);

  const standardChangeFn = shallowRef();

  const standardChange = (fn: Function) => {
    standardChangeFn.value = fn;
  };

  const getStandardByKey = async () => {
    try {
      if (!getBindValue.value.byKeyApi)
        throw new Error('byKeyApi is required or Through the configProvider injection configuration');
      const key = unref(getBindValue).sKey;
      standard.value = await getBindValue.value.byKeyApi({ key });
    } catch (e) {
      console.error(e);
    }
  };

  const getStandard = async () => {
    try {
      if (!getBindValue.value.allApi)
        throw new Error('allApi is required or Through the configProvider injection configuration');
      const key = unref(getBindValue).sKey;
      if (unref(version) !== unref(oldVersion)) {
        const data = await getBindValue.value.allApi();
        data.forEach(e => {
          standardRec.value[e.key] = e;
        });
        oldVersion.value = version.value;
      }
      standard.value = standardRec.value[key];
    } catch (e) {
      console.error(e);
    }
  };

  onMounted(async () => {
    try {
      loading.value = true;
      if (unref(getBindValue).allApi) await getStandard();
      else if (unref(getBindValue).byKeyApi) await getStandardByKey();
      if (standardChangeFn.value) standardChangeFn.value();
      loading.value = false;
    } catch (err) {
      loading.value = false;
    }
  });

  return { getBindValue, standard, standardChange, loading };
};
